export const NET_COLOR = "var(--color-gray-600)";
export const INTEREST_COLOR = "var(--color-success)";
export const CASHBACK_COLOR = "var(--color-info)";
export const LOSS_COLOR = "var(--color-error)";
